import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DropdownBase from '../DropdownBase/DropdownBase';

export default class Dropdown extends Component {
    static propTypes = {
        /** id attribute of the Dropdown. Used for aria-labeledby value of dropdown list. */
        id: PropTypes.string.isRequired,
        /** Text to display on the Dropdown button. */
        label: PropTypes.node.isRequired,
        /** Array of links to generate.  Shape contains: `link`, `text`, and `cssClass`. */
        links: PropTypes.arrayOf(
            PropTypes.shape({
                link: PropTypes.string,
                text: PropTypes.string,
                className: PropTypes.string
            })
        ),
        /** Event handler to fire when dropdown has opened. */
        onDropdownShow: PropTypes.func,
        /** Event handler to fire when dropdown has closed. */
        onDropdownHide: PropTypes.func,
        /** Flag to control if the Dropdown is open via an external state management. */
        open: PropTypes.bool,
        /** Child content of Dropdown button if not using standard label prop. */
        buttonChildren: PropTypes.node,
        /** Render the toggle as a custom React component. */
        customToggle: PropTypes.element,
        /** Flag to specify that the button label is Screen Reader only. Usually used with props.buttonChildren. */
        srOnlyLabel: PropTypes.bool,
        /** Flag to keep the arrow icon from appearing to the right of the text. */
        noArrow: PropTypes.bool,
        /** Flag to keep have the dropdown menu open from the right. */
        dropdownRight: PropTypes.bool,
        /** Flag to keep the component open upon children updating */
        ignoreNextProps: PropTypes.bool,
        /** Set max height of the dropdown menu */
        maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        /** A11y role, use role 'menu' to enable arrow keys navigation. */
        role: PropTypes.string,
        /** Flag to determine if the dropdown should close after click - defaults to false */
        closeAfterContentClick: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            open: props.open || false
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.open !== prevState.open) {
            if (this.state.open) {
                if (this.props.onDropdownShow) {
                    this.props.onDropdownShow();
                }
            } else if (this.props.onDropdownHide) {
                this.props.onDropdownHide();
            }
        }
    }

    openDropdown = () => {
        this.setState({open: true});
    };

    closeDropdown = () => {
        this.setState({open: false});
    };

    handleDropdownClick = () => {
        const {open} = this.state;
        if (open) {
            this.setState({open: false});
        } else {
            this.setState({open: true});
        }
    };

    handleDropdownContentClick = () => {
        const {open} = this.state;
        const {closeAfterContentClick} = this.props;

        if (open && closeAfterContentClick) {
            this.setState({open: false});
        }
    };

    render() {
        return (
            <DropdownBase
                {...this.props}
                onTouch={this.closeDropdown}
                onBlur={this.closeDropdown}
                onDropdownClick={this.handleDropdownClick}
                onDropdownContentClick={this.handleDropdownContentClick}
                open={this.state.open}
            />
        );
    }
}
